<template>
  <div>
    <tx-action txType="Grant LP Autocompound" />
    <div class="d-flex justify-center mt-16">
      <div class="deposit-box pa-10">
        <c-tx-steps
          class="mt-6"
          borderType="stake"
          :options="[{ step: 1, text: 'Gas Option' }]"
          :current="1"
        />
        <div>
          <gas-option :gas="defaultGas" v-model="gasOption">
            <div class="d-flex mt-10">
              <div>
                <div class="text-5 font-weight-medium">Transaction Fee</div>
                <div class="d-flex align-baseline mt-4 text-2">
                  <span class="primary--text">{{
                    gasOption.gasPrice | denomFormat
                  }}</span>
                  <span class="gray--text text-uppercase ml-1">{{
                    currentProject.staking.token
                  }}</span>
                </div>
                <div class="mt-2 gray--text text-5">
                  ${{ gasPriceUsd | currency }}
                </div>
              </div>
            </div>
          </gas-option>
          <div class="mt-16">
            <v-tooltip
              top
              color="dark"
              :disabled="!btnConfirmDisabled"
              max-width="350"
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <c-btn
                    @click="confirm"
                    :disabled="btnConfirmDisabled"
                    class="width-100"
                    >Confirm</c-btn
                  >
                </span>
              </template>
              <span v-if="isSufficentFees">
                This feature is not available at the moment.
              </span>
              <span v-else
                >Your balance is not enough to pay for the transaction
                fees.</span
              >
            </v-tooltip>
            <div class="mt-6 text-center">
              <i class="text-5 line-height-1 darkgray--text">
                Note: This transaction can only be signed with Keplr wallet.
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tx-tendermint
      v-if="showTxDialog"
      name="enable_lp_auto_compound"
      title="Enable LP Autocompound"
      successMesssage="Transaction sent"
      :getRawTx="getRawTx"
      :metadata="{}"
      :gasOption="gasOption"
      @cancel="showTxDialog = false"
      @onSuccess="onTxSuccess"
    >
    </tx-tendermint>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import TxAction from "@/views/stake/components/tx/TxAction.vue";
import EnterAmount from "@/views/stake/components/tx/EnterAmount.vue";
import GasOption from "../components/GasOption.vue";

export default {
  components: {
    TxAction,
    EnterAmount,
    GasOption,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      accountInfo: "staking/tendermint/accountInfo",
      locks: "staking/tendermint/osmosis/autocompoundLocks",
    }),
    availableBalance() {
      return new BN(this.accountInfo?.result?.total ?? 0)
        .dividedBy(this.currentProject.staking.conversionRate)
        .toString();
    },
    defaultGas() {
      return this.currentProject.staking.gas.EnableAutoCompound;
    },
    defaultGasPrice() {
      return new BN(this.currentProject.staking.gasPriceStep.medium)
        .multipliedBy(this.defaultGas)
        .div(this.currentProject.staking.conversionRate)
        .toNumber();
    },
    gasPriceUsd() {
      return (
        this.getTokenPriceInUsd(this.currentProject.staking.token) *
        this.gasOption.gasPrice
      );
    },
    isSufficentFees() {
      return new BN(this.availableBalance).isGreaterThanOrEqualTo(
        this.gasOption.gasPrice || this.defaultGasPrice
      );
    },
    btnConfirmDisabled() {
      return (
        this.gasOption.gas <= 0 ||
        this.gasOption.gasPrice <= 0 ||
        !this.isSufficentFees
      );
    },
  },
  data: () => ({
    gasOption: {
      gas: 0,
      gasPrice: 0,
    },
    showTxDialog: false,
  }),
  methods: {
    confirm() {
      this.showTxDialog = true;
    },
    async getRawTx() {
      const dateNow = new Date();
      const expiration = new Date(
        dateNow.getFullYear() + 1,
        dateNow.getMonth(),
        dateNow.getDate()
      ).valueOf();
      return this.$store.dispatch(
        "staking/tendermint/osmosis/getGrantLpAutocompoundRawTx",
        {
          gas: this.gasOption.gas,
          gasPrice: new BN(this.gasOption.gasPrice)
            .multipliedBy(this.currentProject.staking.conversionRate)
            .toNumber(),
          expiration,
        }
      );
    },
    async updateAutocompoundPools() {
      const pools = this.locks
        .filter(item => item.delegatedToUs && item.shares > 0)
        .map(item => Number(item.pool.id));
      await this.$store.dispatch(
        "staking/tendermint/osmosis/requestAutocompoundForPools",
        { pools }
      );
      this.$store.dispatch("staking/tendermint/osmosis/getPoolsAutocompound");
    },
    onTxSuccess() {
      this.showTxDialog = false;
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
      });
      this.$emit("close");
      this.updateAutocompoundPools();
    },
  },
};
</script>
